import React from 'react'
import { Button, Card, CardContent, CardHeader, Grid, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f1f1f1',
  },
  card: {
    width: '520px',
  },
  btn: {
    height: 56,
    fontSize: '1.05rem',
  },
}))

export default function RoleSelect({ onSelectRole }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Card elevation={6} className={classes.card}>
        <CardHeader title="انتخاب نقش فعال" />
        <CardContent>
          <Typography variant="body1" style={{ marginBottom: 24 }}>
            لطفاً نقش موردنظر برای ورود را انتخاب کنید:
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.btn}
                onClick={() => onSelectRole('Consultant')}
              >
                ورود به عنوان مشاور
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.btn}
                onClick={() => onSelectRole('Contractor')}
              >
                ورود به عنوان پیمانکار
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  )
}
